
import { Star, StarHalf } from "lucide-react";

interface StarRatingProps {
  score: number;
  isMobile: boolean;
}

export const StarRating = ({ score, isMobile }: StarRatingProps) => {
  const fullStars = Math.floor(score);
  const hasHalfStar = Math.round(score % 1 * 2) === 1;
  const starSize = "h-3.5 w-3.5";

  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center gap-0.5">
        {[...Array(fullStars)].map((_, i) => (
          <Star key={`full-${i}`} className={`${starSize} fill-yellow-400 text-yellow-400`} />
        ))}
        {hasHalfStar && <StarHalf className={`${starSize} text-yellow-400`} />}
      </div>
      <span className="text-sm font-medium ml-1">
        {score.toFixed(1)}
      </span>
    </div>
  );
};
